// Define the Splide configuration object
const splideConfig = {
    perPage: 1,
    focus  : 0,
    omitEnd: true,
    perMove: 1,
    type: 'loop',

    pagination: false, // Set these to false initially
    arrows: false,     // We'll control them via overflow
    drag: false,      
  };
  
  // Function to initialize Splide
  function initSplide() {
    const splide = new Splide('#clinical-slider', splideConfig);
    
    // Add overflow event handler
    splide.on('overflow', function(isOverflow) {
        const options = {
            arrows: isOverflow,
            drag: isOverflow
        };
        
        // Update the slider options
        splide.options = {...splide.options, ...options};
        
        // Refresh the slider to apply changes
        if (splide.initialized) {
            splide.refresh();
        }
    });
    
    splide.mount();
  }
  
  // Add event listeners
  document.addEventListener('DOMContentLoaded', initSplide);
  document.addEventListener('shopify:section:load', initSplide);